import React from "react";
import MDButton from "components/MDButton";
import config from "config/config";
import googleIcon from "../../../../assets/images/icons/catering-rewards/google_icon.png";
import PropTypes from "prop-types";

function SignInWithGoogle({ gtmCode, campaignCode, campaignDetails, storeId, brandId, onBeforeSignIn }) {
  const googleLogin = () => {
    if (onBeforeSignIn && !onBeforeSignIn()) {
      return; // Stop if validation fails
    }

    const state = {
      gtmCode: gtmCode ? gtmCode.replace("GTM-", "") : "",
      ...(storeId
        ? { restaurantStoreId: storeId, ...(!campaignDetails && { origin: "LANDING" }) }
        : brandId
        ? { brandId, ...(!campaignDetails && { origin: "BRAND_LANDING" }) }
        : {}),
      ...(campaignDetails && { campaignCode }),
    };

    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${
      config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].GOOGLE_CLIENT_ID
    }&redirect_uri=${
      config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].GOOGLE_REDIRECT_URI
    }&response_type=code&scope=openid%20email%20profile&access_type=offline&prompt=consent&state=${encodeURIComponent(
      JSON.stringify(state)
    )}`;
    window.location.href = googleAuthUrl;
  };

  return (
    <div>
      <MDButton
        variant="outlined"
        color="secondary"
        fullWidth
        onClick={() => googleLogin()}
        sx={{
          borderRadius: "8px",
          py: 1.5,
          background: "#E8E8E8",
          borderColor: "#E8E8E8",
          marginTop: "1rem",
          color: "#475467",
          textTransform: "none",
          fontWeight: "500",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          "&:hover": {
            background: "#D1D1D1",
            borderColor: "#D1D5DB",
            color: "#101828",
          },
          "&.Mui-disabled": {
            borderColor: "#D1D5DB",
          },
        }}
      >
        <img src={googleIcon} alt="Google" style={{ width: 22, height: 22 }} />
        Continue with Google
      </MDButton>
    </div>
  );
}
export default SignInWithGoogle;

SignInWithGoogle.propTypes = {
  gtmCode: PropTypes.string,
  campaignCode: PropTypes.string,
  campaignDetails: PropTypes.object,
  storeId: PropTypes.string,
  brandId: PropTypes.string,
  onBeforeSignIn: PropTypes.func,
};
